import React from "react";
import {
	Button,
	Col,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from "reactstrap";
import { Field, reduxForm } from "redux-form";

import Input from "components/ReduxForm/Input";
import { MONEY } from "components/NumberFormat";
import renderSelectField from "shared/components/form/Select";

import { onboardPhase, onboardTouch } from "types/onboardPhase";

export const touchOptions = Object.keys(onboardTouch).map(value => ({
	value,
	label: onboardTouch[value]
}));

export const phaseOptions = Object.keys(onboardPhase).map(value => ({
	value,
	label: onboardPhase[value]
}));

const toMoneyNumber = value => {
	if (value === undefined || value === null || value === "") return null;
	if (typeof value === "number") return value;

	const isNegative = String(value)
		.trim()
		.startsWith("-");
	const digits = String(value)
		.replace(/[^\d,]/g, "")
		.replace(",", ".");

	if (!digits) return value;

	const amount = Number(digits);

	return isNegative ? -amount : amount;
};

function ManagementDataModal({
	toggle,
	modalOpen,
	handleSubmit,
	submitting,
	error
}) {
	return (
		<Modal isOpen={modalOpen} toggle={toggle} size="lg">
			<form className="form" onSubmit={handleSubmit}>
				<ModalHeader toggle={toggle}>Dados de gestão</ModalHeader>
				<ModalBody>
					<Row>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">Vendedor</span>
							<div className="form__form-group-field">
								<Field name="salerName" component={Input} type="text" />
							</div>
						</Col>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">Gerente de Contas</span>
							<div className="form__form-group-field">
								<Field
									name="accountManagerName"
									component={Input}
									type="text"
								/>
							</div>
						</Col>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">Fase</span>
							<div className="form__form-group-field">
								<Field
									name="phase"
									component={renderSelectField}
									placeholder="Selecione"
									options={phaseOptions}
								/>
							</div>
						</Col>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">Etapa</span>
							<div className="form__form-group-field">
								<Field name="step" component={Input} type="text" />
							</div>
						</Col>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">Touch</span>
							<div className="form__form-group-field">
								<Field
									name="touch"
									component={renderSelectField}
									placeholder="Selecione"
									options={touchOptions}
								/>
							</div>
						</Col>
						<Col xs={12} md={6} className="form__form-group">
							<span className="form__form-group-label">MRR</span>
							<div className="form__form-group-field">
								<Field
									name="mrr"
									component={MONEY}
									normalize={toMoneyNumber}
									placeholder="R$ 0,00"
								/>
							</div>
						</Col>
					</Row>
					{error && <span className="form__form-group-error">{error}</span>}
				</ModalBody>
				<ModalFooter>
					<Button color="primary" type="submit" disabled={submitting}>
						Salvar
					</Button>
					<Button type="button" onClick={toggle}>
						Cancelar
					</Button>
				</ModalFooter>
			</form>
		</Modal>
	);
}

const validate = values => {
	const errors = {};

	if (!values.phase) errors.phase = "Selecione a fase";

	const mrr = values.mrr;
	const hasMrr = mrr !== undefined && mrr !== null && mrr !== "";

	if (hasMrr && (typeof mrr !== "number" || Number.isNaN(mrr))) {
		errors.mrr = "Informe um valor numérico";
	} else if (hasMrr && mrr < 0) {
		errors.mrr = "O MRR não pode ser negativo";
	}

	return errors;
};

export default reduxForm({
	form: "onboard_management_data_edit",
	enableReinitialize: true,
	validate
})(ManagementDataModal);
